import React from 'react';
import { useTranslation } from 'react-i18next';

function TrackmanLegendChart() {
    const { t } = useTranslation();
    let fontSize = '14px';
    return (
        <div id="legend" style={{width: '33%', textAlign: 'center'}}>
            <svg width="110" height="40">
                <g transform="translate(15,0)">
                    <line x1="0" x2="73" y1="16" y2="16" stroke="#9b9b9b" strokeWidth="3px"></line>
                    <circle cx="0.365" cy="16" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                    <circle cx="73.365" cy="16" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                    <circle cx="36.5" cy="16" r="2" fill="#9b9b9b" stroke="#9b9b9b"></circle>
                </g>
                <g transform="translate(5,35)">
                    <text fill='#3661AD' fontWeight={'bold'} fontSize={fontSize}>{t('Poor')}</text>
                </g>
                <g transform="translate(38,35)">
                    <text fill='#000' fontWeight={'bold'} fontSize={fontSize}>{t('Avg')}</text>
                </g>
                <g transform="translate(70,35)">
                    <text fill="#D82129" fontWeight={'bold'} fontSize={fontSize}>{t('Good')}</text>
                </g>
            </svg>
        </div>
    )
}

export default TrackmanLegendChart;